import { addHocItem } from "@/api/adhoc-items";
import Dropdown, { Item } from "@/components/form/Dropdown";
import NumberInput from "@/components/form/NumberInput";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import {
  AdhocItem,
  AdhocItemType,
  AdhocItemTypeLabels,
} from "@/models/adhoc-items.model";
import React, { useState } from "react";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
  updateAdhocItems: (item: AdhocItem) => void;
}

export const adhocItemTypeArray: Item[] = Object.values(AdhocItemType).map(
  (value) => ({
    value: value,
    label: AdhocItemTypeLabels[value],
  })
);

function AddAdhocForm({
  userId,
  month,
  year,
  payslipId,
  updateAdhocItems,
}: Props) {
  const [type, setType] = useState<string>("");
  const [amount, setAmount] = useState<number>(0);
  const [err, setErr] = useState<string>("");
  const isValid = () => {
    if (type === "" || amount === 0) {
      setErr("Please fill all fields.");
      return false;
    }
    if (amount <= 0) {
      setErr("Amount must be greater than 0.");
      return false;
    }
    setErr("");
    return true;
  };

  const handleAdhocItem = async () => {
    if (!isValid()) {
      return;
    }
    // Add adhoc item
    try {
      const adhocItem = await addHocItem({
        amount,
        type: type as AdhocItemType,
        userId,
        month,
        year,
        payslipId,
      });
      updateAdhocItems(adhocItem);
      if (adhocItem) {
        toast({
          title: "Adhoc item added",
          description: `Adhoc item ${
            AdhocItemTypeLabels[type as AdhocItemType]
          } added successfully`,
        });
        setErr("");
        setType("");
        setAmount(0);
      }
    } catch (err) {
      console.error(err);
      toast({
        title: "Error",
        description: "Failed to add adhoc item",
        variant: "destructive",
      });
    }
  };
  return (
    <div className="flex gap-2 flex-col mt-3">
      <div className="flex gap-2 items-end">
        <Dropdown
          label="Type"
          items={adhocItemTypeArray}
          selectedString={type}
          setSelectedString={setType}
        />
        <NumberInput
          label="Amount"
          value={amount}
          setValue={setAmount}
          placeholder="Amount"
        />
        <Button onClick={handleAdhocItem} type="submit">
          Add
        </Button>
      </div>
      {err && <div className="text-red-500 text-sm">{err}</div>}
    </div>
  );
}

export default AddAdhocForm;
